export default "__VITE_ASSET__AinpBmyX__"